import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { API } from 'network/api';
import { Document, Pipe, TaskAssignment } from 'types/common';
import { FertilizerLog } from './useFertilizerQuery';

type DryEventLog = {
  id: string;
  taskAssignment: TaskAssignment;
  mrvResourcesDto: Pipe;
  yeild: string;
  sellingPrice: string;
  createdAt: string;
  startDate: string;
  images: string;
  notes: string;
  waterLevel: string;
  fertilizerLogs: FertilizerLog[];
  documentList: Document[];
};

const useDryEventQuery = (id?: string, taskId?: string) => {
  const query = useQuery<AxiosResponse<DryEventLog>, AxiosError>({
    queryKey: ['drying-event-data', id, taskId],
    queryFn: () =>
      API.get(`/tasklog/drying_event/${id}?taskAssignmentId=${taskId}`),
    enabled: !!id && !!taskId,
    retry: (failureCount, error) => {
      if (error.response?.status === 400) return false;
      return failureCount < 3;
    },
  });

  return query;
};

export default useDryEventQuery;
